import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Edit, Clock, CheckCircle, XCircle, FileText, Calendar } from 'lucide-react';

const statusConfig = {
  pending: { color: 'bg-amber-100 text-amber-700', icon: Clock, label: 'Pending Review' },
  approved: { color: 'bg-green-100 text-green-700', icon: CheckCircle, label: 'Approved' },
  rejected: { color: 'bg-red-100 text-red-700', icon: XCircle, label: 'Rejected' },
  revision_required: { color: 'bg-blue-100 text-blue-700', icon: Edit, label: 'Revision Required' }
};

export function CurriculumUpdatesTab({ updateRequests }) {
  if (!updateRequests || updateRequests.length === 0) {
    return (
      <div className="text-center py-12">
        <Edit className="h-12 w-12 mx-auto mb-4 text-slate-300" />
        <p className="text-slate-500">No update requests submitted</p>
        <p className="text-xs text-slate-400 mt-2">
          Submit curriculum updates from the Certificates tab
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {updateRequests.map((update) => {
        const config = statusConfig[update.status] || statusConfig.pending;
        const StatusIcon = config.icon;
        
        return (
          <Card key={update.id}>
            <CardContent className="p-4">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <Badge variant="outline" className="text-xs">
                      {update.update_type?.replace('_', ' ')}
                    </Badge>
                    <Badge className={config.color}>
                      <StatusIcon className="h-3 w-3 mr-1" />
                      {config.label}
                    </Badge>
                  </div>
                  
                  <h3 className="font-medium text-[#1B2A4A] mb-1">{update.description}</h3>
                  
                  {update.changes_summary && (
                    <p className="text-sm text-slate-600 mb-2">{update.changes_summary}</p>
                  )}
                  
                  <div className="flex flex-wrap gap-4 text-xs text-slate-500">
                    <span className="flex items-center gap-1">
                      <Calendar className="h-3 w-3" />
                      Submitted: {new Date(update.submitted_at).toLocaleDateString()}
                    </span>
                    {update.effective_date && (
                      <span className="flex items-center gap-1">
                        <Calendar className="h-3 w-3" />
                        Effective: {new Date(update.effective_date).toLocaleDateString()}
                      </span>
                    )}
                  </div>
                  
                  {update.admin_comments && (
                    <div className="mt-3 p-3 bg-slate-50 rounded-sm">
                      <p className="text-xs font-medium text-slate-700 mb-1">Admin Comments:</p>
                      <p className="text-xs text-slate-600">{update.admin_comments}</p>
                    </div>
                  )}
                  
                  {update.document_url && (
                    <Button 
                      size="sm" 
                      variant="outline" 
                      className="mt-3 rounded-sm"
                      onClick={() => window.open(update.document_url, '_blank')}
                    >
                      <FileText className="h-3 w-3 mr-1" /> View Document
                    </Button>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
